import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table } from "reactstrap";
import { TableSection } from "../myOrderStyled";
import { postNeedSpecApi } from 'redux/actions/ptPlusPage'

import { downloadFile } from 'redux/actions/helper/downloadFile';
import PtPlusPagePostIcon from "web/assets/svg/PtPlusPagePostIcon";
import PtPlusPageModifyIcon from "web/assets/svg/PtPlusPageModifyIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import PtPlusPageSpecDownloadIcon from "web/assets/svg/PtPlusPageSpecDownloadIcon";
import PtPlusPageInfoIcon from "web/assets/svg/PtPlusPageInfoIcon";
import ChatIcon from "web/assets/svg/ChatlogsIcon";
import * as moment from "moment";
import AlertModal from "web/components/AlertModal";
import YesNoModal from 'web/components/YesNoModal';
import editPostJson from '../editPostJson.json'
import DisplayLogs from '../PopUpModals/DisplayLogs'
import DeleteLogs from '../PopUpModals/Deleatlogs'
import { abbreviationToState, stateConvert } from "web/components/utils/stateAbbreviation";
import { deleteOrder } from "redux/actions/requestOrderPtplus";
import RequestPickupTenderModal from "../PopUpModals/RequestPickupTenderModal"
import RequestDeliveryTenderModal from "../PopUpModals/RequestDeliveryTenderModal"

function PendingPostsTable(props) {
  const dispatch = useDispatch()
  let history = useHistory()
  const token = localStorage.getItem("token")
  const [actionPopUpOpenIndex, setActionPopUpOpenIndex] = useState(false)
  const [deleteactionPopupOpenIndex, setdeleteactionPopupOpenIndex] = useState(false)
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [alertType, setAlertType] = useState();
  const [modalResult, setModalResult] = useState("");
  const toggleModal = () => setAlertModal(!alertModal);

  const [deleteOrderRefNumber, setDeleteOrderRefNumber] = useState()
  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const yesNoToggleModal = () => setYesNoModalOpen(!yesNoModalOpen);
  const [yesNoModalContent, setYesNoModalContent] = useState();
  const [yesNoModalAlertType, setYesNoModalAlertType] = useState();

  const [requestPickupTenderModalIsOpen, setRequestPickupTenderModalIsOpen] = useState(false)
  const [requestDeliveryTenderModalIsOpen, setRequestDeliveryTenderModalIsOpen] = useState(false)

  const headerArray = [
    { title: 'Ref. No.' },
    { title: 'PO#' },
    { title: 'Location – City, State' },
    { title: 'Qty, Order Type' },
    { title: 'Type' },
    { title: 'Requested Date', },
    { title: "Actions" },
  ]

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + ', NA'

    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let size = "";
    let grade = "";
    let LWH
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + ", " + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size)
        size = ", " + items?.palletDetails?.size

      if (items?.palletDetails?.grade)
        grade = ", " + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      return totalQuantity + "" + size + "" + grade + ", " + palletType + "-" + condition
    }
  }

  // forming the json in the same format as we pass while editing the post need in PT, so all methods and functions in that component can be reused.
  const formPageData = (editDataTemplate, ptSpecData, items) => {
    // let resultPageData = editDataTemplate
    let conditionList = items.palletDetails.condition
    conditionList = conditionList.map(word => {
      return word;
    });

    let length
    let width
    let height
    if ((items.palletDetails.size === 'Custom' || items.palletDetails.material === 'PLASTIC' || items.palletDetails.material === 'OTHER') && items.palletDetails.length) {
      length = items.palletDetails.length
      width = items.palletDetails.width
      height = items.palletDetails.height
    }

    let moisture;
    if (items.palletDetails?.moisture && items.palletDetails?.moisture !== '') {
      moisture = items?.palletDetails?.moisture
    }

    let vehiclestemp = items.equipmentRequirements || []
    vehiclestemp = vehiclestemp.map(word => {
      if (word === 'ENCLOSED_TRAILER') {
        return 'VAN';
      } else if (word === 'STRAIGHT_TRUCK') {
        return 'STRAIGHT';
      } else {
        return word;
      }
    });


    let resultPageData = {
      id: items?.id,
      postedUserDetails: {
        locationId: items?.location,
        locationsId: items?.locationsId || [],
        // userRole: "BROKER",
        fcMember: false
      },
      shippingAddress: {
        locationName: items?.addressDTO?.locationName,
        address1: items?.addressDTO?.street,
        address2: null,
        city: items?.addressDTO?.city,
        state: abbreviationToState(items?.addressDTO?.state) || items?.addressDTO?.state,
        stateAbv: abbreviationToState(items?.addressDTO?.state),
        zipCode: items.addressDTO?.zipCode,
        country: "US",
        locationDaysOfOperations: undefined,
      },
      postTitle: items?.title || '',
      postImageFiles: items?.productImage ? items?.productImage : null,
      palletDetails: {
        material: items.palletDetails.material ? items.palletDetails.material : null,
        condition: conditionList ? conditionList : null,
        palletType: ptSpecData ? ptSpecData?.commodity?.commodityName : null,
        moisture: moisture ? moisture : null,
        size: items?.palletDetails?.size ? items?.palletDetails?.size : null,
        grade: ptSpecData && ptSpecData?.grade?.sizeWiseGrad ? ptSpecData?.grade?.sizeWiseGrad : null,
        length: length,
        width: width,
        height: height,
        heatTreared: items.palletDetails.heatTreared ? items.palletDetails.heatTreared : false,
        newConditionType: items?.palletDetails?.newConditionType ? items?.palletDetails?.newConditionType : null
      },
      specificationFiles: items?.specificationFiles ? items?.specificationFiles : [],
      // postImageFiles:items?.productImage? items?.productImage:[],

      shippingMode: "DELIVERABLE",
      vehiclePreferences: vehiclestemp,
      requestedDate: moment(items?.requestDeliveryDate).format('YYYY-MM-DD'),
      distanceWillingToTravel: items?.distanceWillingToTravel || null,
      unLoadingReq: "LIVE",
      appointmentType: items?.appointmentType ? items?.appointmentType : "DELIVERY_WINDOW",
      appointmentStartTime: items?.deliveryFromTime ? items?.deliveryFromTime : items?.appointmentType ? items?.deliveryFromTime : null,
      appointmentEndTime: items?.deliveryToTime ? items?.deliveryToTime : null,
      // appointmentStartTime: items?.deliveryFromTime ? `${items?.deliveryFromTime}:00` : items?.appointmentType? `${items?.deliveryFromTime}:00`:null,
      // appointmentEndTime: items?.deliveryToTime ? `${items?.deliveryToTime}:00` : null,
      lotDetails: {
        totLots: items?.quantityDetails?.lots ? items?.quantityDetails?.lots : 1,
        qtyPerLot: items?.quantityDetails?.quantity ? items?.quantityDetails?.quantity : 540,
        totalQty: items?.quantityDetails?.quantity ? items?.quantityDetails?.totalQuantity : 540,
        lotPostingOption: "SplitByLot",
        originalQty: items?.quantityDetails?.originalQuantity ? items?.quantityDetails?.originalQuantity : 540,
      },
      quantity: items?.quantityDetails?.quantity ? items?.quantityDetails?.quantity : 540,
      targetPrice: '',//2.0,
      displayCostToMarket: true,
      // postPreferences: {
      //     acceptanceMethod: "MANUAL",
      //     bidCloseTime: "2023-11-10T12:39:00",
      //     bidCloseTimeEpocSeconds: 1699637940,
      //     postingMethod: "MARKET",
      //     groupIdsList: null,
      //     postVisibilityLocationIds: null
      // },
      status: items?.orderStatus,
      favorite: false,
      editType: "ptplusorder",
      comments: items?.comments ? items?.comments : '',
      // postType: "NEED",
      postRecurrence: items?.postRecurring,
      // orderRecurrence: items?.orderRecurrence,
      // ownPost: true,
      // bidAlreadyMade: false,
      PtPlusEditData: true,
      plusDetails: {
        orderRefNumber: items.orderRefNumber,
        poNumber: items.poNumber,
        flatFee: items.flatFee,
        comment: items?.comment ? items?.comment : '',
      },
      recurringOrderDetails: items.recurringDetails ? items.recurringDetails : null,
      recurringSummaryText: items.recurringDetails ? frameRecurringOrderSummary(items.recurringDetails) : null,
      isRecurring: items.recurringDetails ? true : false

    }
    return resultPageData
  }

  const frameRecurringOrderSummary = (data) => {
    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    function getWeekDaysInSequence(a, b) {
      const daysOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      return daysOrder.indexOf(a) - daysOrder.indexOf(b);
    }
    let recTypeValue = capitalizeFirstLetter(data.recType || '')
    let recValuesText = ''
    if (data.recType === 'WEEKLY') {
      let weeklyDaysTemp = data.pattern?.weekly?.weekdays?.map(data => `${capitalizeFirstLetter(data).substring(0, 3)}`)
      weeklyDaysTemp = weeklyDaysTemp?.sort(getWeekDaysInSequence)
      recValuesText = `Every ${weeklyDaysTemp} for
                ${data.pattern?.weekly?.recuringEvery} week(s), Starting ${moment(data.startDate).format('MM/DD/YYYY')}, Ending ${moment(data.endDate).format('MM/DD/YYYY')}`
    } else if (data.recType === 'MONTHLY') {
      if (data.pattern?.monthly?.monthlyType === 'DAY') {
        recValuesText = `Day ${data.pattern?.monthly?.dayType?.recuringDay} for every ${data.pattern?.monthly?.dayType?.recuringEvery} month(s), Starting ${moment(data.startDate).format('MM/DD/YYYY')}, Ending ${moment(data.endDate).format('MM/DD/YYYY')}`
      } else if (data.pattern?.monthly?.monthlyType === 'CUSTOM') {
        recValuesText = `${capitalizeFirstLetter(data.pattern?.monthly?.custom?.weekOfMonth)} ${capitalizeFirstLetter(data.pattern?.monthly?.custom?.reccuringWeek).substring(0, 3)} for every ${data.pattern?.monthly?.custom?.recuringEvery} month(s), Starting ${moment(data.startDate).format('MM/DD/YYYY')}, Ending ${moment(data.endDate).format('MM/DD/YYYY')}`
      }
    }
    return `${recTypeValue}: ${recValuesText}`
  }

  const postNeedFunction = async (items) => {
    let response, pagedata
    let data = items.palletDetails
    let editDataTemplate = JSON.parse(JSON.stringify(editPostJson))
    if (items.palletDetails.material === 'OTHER') {
      pagedata = formPageData(editDataTemplate, undefined, items)
      let obj = {
        postType: "PostLoad",
        id: items.id,
        expanded: "panel1",
        activePage: "PostLoad",
        ptplusAdminPost: true,
        pagedata: pagedata
      };
      dispatch({
        type: "POST_LOAD_URL",
        payload: obj,
      });
      history.push("/post-my-pallet-needs")
    } else {
      response = await dispatch(postNeedSpecApi(data, token))
      if (response?.status === 'SUCCESS') {
        pagedata = formPageData(editDataTemplate, response.payload, items)
        let obj = {
          postType: "PostLoad",
          id: items.id,
          expanded: "panel1",
          activePage: "PostLoad",
          ptplusAdminPost: true,
          pagedata: pagedata
        };
        dispatch({
          type: "POST_LOAD_URL",
          payload: obj,
        });
        history.push("/post-my-pallet-needs")
      } else {
        if (response?.data?.error?.message === "Invalid Token" || response?.data?.error?.message === 'Request failed with status code 401') {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!')
          setAlertModal(!alertModal)
        }
      }

    }
  }

  const editOrder = (items, id, title) => {
    let obj = {
      id: id,
      items: items
    };
    dispatch({ type: "REQUESTED_ID", payload: obj });
    localStorage.setItem('editRequestOrderUser', true)
    history.push("/ptplus-request-order-modify")
  }

  const editPickupRequestOrder = (items) => {
    localStorage.setItem('ordRefNoForFetchReqPickOrd', items?.orderRefNumber)
    history.push("/ptplus-request-pickup-order")
  }

  const deleteRequestOrderConfirmation = (items) => {
    setDeleteOrderRefNumber(items?.orderRefNumber)
    setYesNoModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to delete the pickup order request?' : 'Are you sure you want to delete the order request?');
    setYesNoModalAlertType(items?.requestType === 'PickUp' ? 'deletePickupRequestOrder' : 'deleteRequestOrder')
    yesNoToggleModal();
  }

  const deleteRequestPickupOrderFunction = async (confirmationAlertType) => {
    let data = {
      orderRefNumber: deleteOrderRefNumber,
      emailId: [localStorage.getItem('email')],
      locationName: localStorage.getItem('companyName')
    }
    let response = await dispatch(deleteOrder(data, token));
    if (response?.data?.success) {
      setDeleteOrderRefNumber()
      setAlertModalContent(confirmationAlertType === 'deletePickupRequestOrder' ? 'Pickup order request deleted successfully!' : 'Order request deleted successfully!')
      setAlertType('success')
      toggleModal();
      setModalResult('successDelete')
    } else {
      setAlertModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
      toggleModal();
    }
  }

  const downloadSpecFiles = async (specificationFiles) => {
    if (specificationFiles?.length > 0) {
      specificationFiles.map(val => {
        let orignalFileName = val.fileName
        dispatch(downloadFile(orignalFileName));
      })
    }
  };

  const requestPickupTenderClick = items => {
    localStorage.setItem('requestTenderSelectedItemId', items.orderRefNumber)
    setRequestPickupTenderModalIsOpen(true)
  }

  const requestDeliveryTenderClick = items => {
    localStorage.setItem('requestTenderSelectedItemId', items.orderRefNumber)
    setRequestDeliveryTenderModalIsOpen(true)
  }

  return (
    <div onClick={() => {
      if (actionPopUpOpenIndex) setActionPopUpOpenIndex(false)
      if (deleteactionPopupOpenIndex) setdeleteactionPopupOpenIndex(false)
    }}>
      <TableSection className="pending-request">
        {/* <Table responsive style={{ minHeight: actionPopUpOpenIndex === 1 ? '350px' : (props.pagedata?.length > 0 && '135px') }}> */}
        <Table responsive style={{ minHeight: actionPopUpOpenIndex === 1 ? '350px' : (props.pagedata?.length > 0 && '225px') }}>
          <thead>
            <tr className="table-header">
              {headerArray.map((items, index) => (
                <th key={index}>{items.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.pagedata && props.pagedata.map((items, index) => (
              <tr key={index}>
                <td>{items.orderRefNumber || 'NA'}</td>
                <td>{items.poNumber?.trim() || 'NA'}</td>
                <td>{items.addressDTO && `${items.addressDTO.locationName} - ${items.addressDTO.city}, ${stateConvert(items.addressDTO.state) || items.addressDTO.state} `}</td>
                <td>{orderType(items)}</td>
                <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                {/* <td>{moment(items.createdAt * 1000).format('MM/DD/YYYY')}</td> */}
                <td>{items?.ptPostedDetailsDTO ? moment(items?.ptPostedDetailsDTO?.requestDeliveryDate).format('MM/DD/YYYY') : moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</td>
                <td>
                  {items?.requestType === 'PickUp' ?
                    <div style={{ display: 'flex', gap: '10px', paddingRight: '6px', cursor: 'pointer' }}>
                      <div onClick={() => requestPickupTenderClick(items)}>
                        <button className="create-order-button-styles">Create Tender</button>
                      </div>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <div onClick={() => editPickupRequestOrder(items)}>
                          <PtPlusPageModifyIcon />
                        </div>
                        <div onClick={() => deleteRequestOrderConfirmation(items)}>
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                    :
                    <div style={{ display: 'flex', gap: "10px", cursor: 'pointer' }}>
                      <div onClick={() => requestDeliveryTenderClick(items)}>
                        <button className="create-order-button-styles">Create Tender</button>
                      </div>
                      <div onClick={() => postNeedFunction(items)}>
                        <PtPlusPagePostIcon />
                      </div>
                      <div onClick={() => editOrder(items, items.orderRefNumber, 'editFlow')}>
                        <PtPlusPageModifyIcon />
                      </div>
                      <div onClick={() => deleteRequestOrderConfirmation(items)}>
                        <DeleteIcon />
                      </div>
                      <div style={{ position: 'relative', opacity: items.specificationFiles?.length === 0 ? '0.4' : '1' }} onClick={() => downloadSpecFiles(items.specificationFiles)}>
                        <PtPlusPageSpecDownloadIcon />
                        {items.specificationFiles?.length !== 0 && <p className="spec-count-style">{items.specificationFiles?.length}</p>}
                      </div>
                      <div onClick={() => {
                        setActionPopUpOpenIndex(index + 1)
                      }}>
                        <PtPlusPageInfoIcon />
                      </div>

                      {actionPopUpOpenIndex === (index + 1) &&
                        <div style={{ position: 'relative' }}>
                          {/* <div className={(actionPopUpOpenIndex > 6) ? 'action-popups align-top' : 'action-popups'} */}
                          <div className='action-popups'
                            onClick={() => localStorage.setItem('infoContentClicked', true)}>
                            <p className='top-arrow'></p>
                            <>
                              <h6>Logs</h6>
                              <div style={{ display: 'grid', maxHeight: '200px', overflowX: 'hidden' }}>
                                <DisplayLogs items={items} />

                              </div>
                            </>
                          </div>
                        </div>
                      }

                      <div onClick={() => {
                        setdeleteactionPopupOpenIndex(index + 1)
                      }}>
                        <ChatIcon />
                        {/* <PtPlusPageInfoIcon /> */}
                      </div>
                      <div style={{ position: 'relative' }}>
                        {deleteactionPopupOpenIndex === (index + 1) &&
                          // <div className={(actionPopUpOpenIndex > 6) ? 'action-popups align-top' : 'action-popups'}
                          <div className='action-popups' style={{ marginLeft: "5%" }}>
                            <p className='top-arrow'></p>
                            <>
                              <h6>Release Logs</h6>
                              <div style={{ display: 'grid', maxHeight: '200px', overflowX: 'hidden' }}>
                                <DeleteLogs items={items} />
                              </div>
                            </>
                          </div>
                        }
                      </div>
                    </div>}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {props.pagedata && props.pagedata.length === 0 &&
          <div><p style={{ width: '100%', textAlign: 'center', position: 'relative', bottom: '40px' }}>No records found</p></div>
        }
      </TableSection>

      <YesNoModal
        isOpen={yesNoModalOpen}
        toggle={yesNoToggleModal}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
            yesNoToggleModal()
          } else {
            deleteRequestPickupOrderFunction(yesNoModalAlertType)
            yesNoToggleModal()
          }
        }}
        content={yesNoModalContent}
        link="/"
      />

      <AlertModal
        isOpen={alertModal}
        toggle={toggleModal}
        title=''
        content={alertModalContent}
        alertType={alertType}
        link=''
        callBackAlert={(val) => {
          if (modalResult === 'successDelete') {
            setModalResult('')
            toggleModal()
            props.deleteCallBack()
          } else toggleModal()
        }}
      />

      {requestPickupTenderModalIsOpen &&
        <RequestPickupTenderModal
          closeModal={() => setRequestPickupTenderModalIsOpen(false)}
          requestTendorSuccessCallBack={() => props.requestTendorCallBack()}
        />
      }

      {requestDeliveryTenderModalIsOpen &&
        <RequestDeliveryTenderModal
          closeModal={() => setRequestDeliveryTenderModalIsOpen(false)}
          requestTendorSuccessCallBack={() => props.requestTendorCallBack()}
        />
      }
    </div>
  )
}

export default PendingPostsTable